require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-uitkerkse-polder.json") })
        }
      }, "path---projecten-uitkerkse-polder");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-uitkerkse-polder!./.cache/json/projecten-uitkerkse-polder.json
// module id = 449
// module chunks = 231608221292675